import { render, staticRenderFns } from "./CartModeHeader.vue?vue&type=template&id=dc2b8aa2&"
import script from "./CartModeHeader.vue?vue&type=script&lang=js&"
export * from "./CartModeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports